<!-- 会员消费记录 -->

<template>
    <div class="address">
        <div class="tableConBox">
            <div class="tableTem">
                <div class="HSpace1"></div>
                <div class="searchBox flex flex-align-center">
                   <div class="searchCon clearfix">
                        <div class="left searchBtn">
                            <button type="button" @click="showUpBox"><i class="el-icon-plus"></i>添加地址</button>
                        </div>
                    </div>
                </div>
                <div class="HSpace2"></div>
                <div class="tableBox">
                    <div class="tableBoxScroll">
                        <table class="titleTable">
                            <tr>
                                <th style="width:50%;text-align:left;padding-left:10%;">收货地址</th>
                                <th style="width:50%;text-align:right;padding-right:10%;">操作</th>
                            </tr>
                        </table>
                        <div class="scrollBox">
                            <div class="scroll">
                                <table class="conTable" :class="{overLengthTable:addressData.length<10}">
                                    <tr v-for="item in addressData">
                                        <td  style="width:50%;text-align:left;padding-left:10%;"><span v-text="item.address"></span></td>
                                        <td   style="width:50%;text-align:right;padding-right:10%;">
                                            <span title="修改" style="margin:0 2%;" v-if="item.id" @click="showUpBox(item)"><i class="iconfont icon-bianji"></i></span>
                                            <span title="删除" @click="delAddr(item)" v-if="item.id"><i class="iconfont icon-icon1460188478041"></i></span>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog
            :title="'添加收货地址'"
            :visible.sync="addAddrBtn"
            size="tiny">
            <div>
                <div class="msgBox clearfix">
                    <div class="left msgItem clearfix">
                        <span class="left itemName"><i>*</i>收货地址</span>
                        <input type="text" class="left itemInput" v-model="addr" placeholder="请输入收货地址" >
                    </div>
                    <div class="left msgItem clearfix">
                        <span class="left itemName">姓名</span>
                        <input type="text" class="left itemInput" v-model="name" placeholder="请输入收货人姓名">
                    </div>
                    <div class="left msgItem clearfix">
                        <span class="left itemName"><i>*</i>手机号</span>
                        <input type="text" class="left itemInput" v-model="phone" placeholder="请输入收货人手机号" >
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <button type="button" @click="addAddrBtn=false" class="cancel">取消</button>
                <button type="button" @click="addAddrFn" class="save">保存</button>
            </span>
        </el-dialog>
    </div>
</template>

<script type="text/javascript">
    import {url} from '@/router/url.js';
    import {BASE_URL} from "./../../../urlConfig";
    export default{
        props: ['pageSize','curStoreId'],
    	data () {
    		return {
                dialogVisible: false,
                addAddrBtn:false,//添加地址按钮
                addressData:[],//地址列表
                addr:'',//收货地址
                name:'',//姓名
                phone:"",
                userName:"",//用户手机号
                addrId:"",
    		}
    	},

        methods: {
            //删除地址
            delAddr(item){
                this.$confirm('此操作将删除该收货地址, 是否继续?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                    //删除地址
                    this.$http({
                        url:BASE_URL+"info-remove",
                        method:"POST",
                        data:{
                            id:item.id
                        }
                    }).then((res)=>{
                        this.getAddress();
                    })
                }).catch(() => {});
            },
            //新建或更新地址
            addAddrFn(id){
                if(!this.addr){
                    this.$message({
                        message: '请填写收货地址',
                        customClass: 'error'
                    })
                    return;
                }
                if(!this.name){
                    this.$message({
                        message: '请填写收货人姓名',
                        customClass: 'error'
                    })
                    return;
                }
                if(!this.phone){
                    this.$message({
                        message: '请填写手机号',
                        customClass: 'error'
                    })
                    return;
                }

                this.$http({
                    url:BASE_URL+"info-merge",
                    method:"POST",
                    data:{
                        id:this.addrId?this.addrId:0,
                        name:this.name,
                        mobile:this.phone,
                        address:this.addr,
                        userName:this.userName
                    }
                }).then((res)=>{
                    this.getAddress();
                    this.addAddrBtn = false;
                    this.addr = '';
                    this.name = '';
                    this.phone = '';
                    this.$message({
                        message: '操作成功！',
                        customClass: 'success'
                    })
                })
            },
            showUpBox(item){
                this.addAddrBtn = true;
                this.addrId = item.id;
                this.addr = item.address;
                this.phone = item.mobile;
                this.name = item.name;
            },
            getAddress(){
                //获取地址列表
                this.$http({
                    url:BASE_URL+"info-list",
                    method:"GET",
                    params:{
                        userName : this.userName
                    }
                }).then((res)=>{
                    this.addressData = res.data;
                    if( this.addressData.length < this.pageSize ){
                        for(let i = 0, len = this.pageSize - this.addressData.length; i < len; i++){
                            this.addressData.push({})
                        }
                    }
                })
            }
        },
        created: function () {
            this.userName = localStorage.getItem("username");
            for (let i = 0; i < this.pageSize; i++) {
                this.addressData.push({})
            }
        },
        activated: function () {
           this.getAddress();
        }
    }
</script>
<style lang="scss">
    @import '../../../../static/css/common.scss';
    @import '../../tableTemplate/tableTem.scss';
    @import '../../tableTemplate/el-dialog.scss';
	@import "./address.scss";
</style>



// WEBPACK FOOTER //
// address.vue?6e659912